export const authReducer = (state = { loading: false, profile: null, profileUpdating: false, profileUpdateError: null, profileUpdateSuccess: null, avatar: null, avatarUploading: false, unreadCount: 0 }, action) => {
    switch (action.type) {
        case 'PROFILE_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'PROFILE_SUCCESS':
            return {
                ...state,
                loading: false,
                profile: action.payload,
                avatar: action.payload?.user?.avatar || state.avatar
            }
        case 'PROFILE_ERROR':
            return {
                ...state,
                loading: false,
                profile: null
            }
        case 'PROFILE_UPDATING':
            return {
                ...state,
                profileUpdating: true,
                profileUpdateError: null,
                profileUpdateSuccess: null
            }
        case 'PROFILE_UPDATE_SUCCESS':
            return {
                ...state,
                profileUpdating: false,
                profileUpdateSuccess: action.payload,
                profileUpdateError: null
            }
        case 'PROFILE_UPDATE_ERROR':
            return {
                ...state,
                profileUpdating: false,
                profileUpdateSuccess: null,
                profileUpdateError: action.payload
            }
        case 'PROFILE_TOKEN_UPDATE':
            return {
                ...state,
                profileUpdateSuccess: null
            }
        case 'AVATAR_UPLOADING':
            return {
                ...state,
                avatarUploading: true
            }
        case 'AVATAR_SUCCESS':
            return {
                ...state,
                avatarUploading: false,
                avatar: action.payload
            }
        case 'AVATAR_ERROR':
            return {
                ...state,
                avatarUploading: false
            }
        case 'UNREAD_COUNT_SUCCESS':
            return {
                ...state,
                unreadCount: action.payload
            }
        default:
            return state
    }
}
